export default __webpack_public_path__ + "structdata5cd8a3.png";